<template>
    <el-dialog 
      :visible="dialogVisible" 
      :append-to-body="true" 
      v-loading="loading" 
      title="" 
      @close="cancel">

      <div :class="$style['delay']">
          <pt-sub-title title="任务延期">
          </pt-sub-title>

          <pt-form-item label="任务日期：" :labelWidth="labelWidth">
            <div :class="$style['box']">
              <p v-for="(item,i) in taskDatas" :key="i">
                <span>{{item.start_time}} - {{item.end_time}}</span>
                <span>|</span>
                <span>任务单  {{item.serialNumber}}</span>
              </p>
            </div>
          </pt-form-item>
          <pt-form-item label="延期日期：" :labelWidth="labelWidth" :required="true">
            <el-date-picker  v-model="form.delayTime" type="date" placeholder="选择日期" data-vv-as="延期日期" v-validate="'required'"></el-date-picker>
          </pt-form-item>
          <pt-form-item label="延期原因：" :labelWidth="labelWidth" :required="true">
            <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.delayReason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
          </pt-form-item>
          <pt-form-item label="备注：" :labelWidth="labelWidth">
            <el-input placeholder="请填写备注" v-model="form.comment" type="textarea"></el-input>
          </pt-form-item>
      </div>
      <div :class="$style['button-div']">
          <el-button type="primary" @click="submit">确认</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'task-delay-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    taskDatas: {
      type: Array,
      default: ()=>[]
    },
  },
  data () {
    return {
      labelWidth:"120px",
      loading:false,
      form:{},
      options:[
				'样品较多，正在进行中，需要延期',
				'缺失标准品或试剂',
				'仪器故障',
				'需要提供仪器配件、色谱柱等',
				'实验结果超标或不符合预期，需重新复测',
				'样品量不够，或样品本身不适用，需要重新寄样',
				'实验后发现方法不合适，需要客户重新提供方法',
				'未提供有效方法，实验需要时间摸索',
				'客户先确认电子数据结果，再进行后续实验或出原始记录',
				'实验员不能正常到岗，需要延期',
				'送至其他部门或外送，需要延期'
			],
      reasonProps: {
        label: 'name',
        value: 'id'
      },
    }
  },
  watch: {
   
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    submit(){
      this.formValidata().then((form)=>{
        console.log('-succ',form)
        this.loading = true
        let data = {
          billId:this.taskDatas[0].billId,
          ids:this.taskDatas.map(e=>e.id),
          ...form
        }
        this.$store.dispatch('taskDelay', data).then(res => {
          this.$message.success('操作成功')
          this.$emit('reload')
          this.cancel()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(()=>{
          this.loading = false
        })
      })
    },
    cancel () {
      this.$emit('close')
    },
    
  }
}
</script>
<style module lang="less">
.delay{
  :global{
    .el-select{
      width: 2.2rem;
    }
  }
}
.box{
  >p{
    display: flex;
    span:nth-child(2){
      margin: 0 10px;
    }
  }
}
.button-div{
  margin-top: 40px;
}
</style>
